import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {StarFillIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {getPromotionTypeName} from "../../../../promotion/helpers/PromotionType";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {getVendorPromotions} from "../../../helpers/get_vendor_promotions";
import {IVendorDetail} from "../../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentPromotions = (props: IProps) => {
    const {vendor} = props;
    const {isMobile} = useUserDevice();
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const promotions = vendor.promotions;
    const renderPromotions = getVendorPromotions({promotions});

    if (renderPromotions.length === 0) {
        return null;
    }

    const promotionOffers = renderPromotions.map((promotion) => ({
        ...promotion,
        offerLink: useOfferLink({
            ...promotion.offer,
            vendor: {slug: vendor.slug}
        })
    }));

    return (
        <>
            <div className={subHeaderStyle}>
                <StarFillIcon size="3" />
                <Text variant="mini_header">OFERTY SPECJALNE</Text>
            </div>
            <div className={promotionWrap}>
                {promotionOffers.map((promotion) => {
                    const handlePromotionClick = () => {
                        if (promotion.offerLink) {
                            window.open(promotion.offerLink, responsiveLinkTarget);
                        }
                    };
                    return (
                        <div key={promotion.id} className={promotionContainerStyle}>
                            <Image
                                width={isMobile ? "120" : "240"}
                                height={isMobile ? "74" : "148"}
                                alt="zdjęcie oferty specjalnej"
                                src={getThumbnailLink(promotion.offer.main_image_url, 375, 211) ?? undefined}
                            />
                            <div className={promotionDetailsContainerStyle}>
                                <Text variant="mini_header" className={promotionHeaderStyle}>
                                    {getPromotionTypeName(promotion.type)}
                                </Text>
                                <Text variant="headline_6" mb={1}>
                                    {promotion.offer.name}
                                </Text>
                                <Text variant="info_txt_1" mb={2}>
                                    {promotion.name}
                                </Text>
                                <Button variant="filled_secondary" size="x-small" className={promotionButtonStyle} onClick={handlePromotionClick}>
                                    {InquiryButtonTypeName.SEE_DETAILS}
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const promotionHeaderStyle = css({
    backgroundColor: "var(--colors-success)",
    p: 0.5,
    mb: 2,
    width: "fit-content",
    textTransform: "uppercase"
});

const promotionDetailsContainerStyle = css({
    display: "flex",
    flexDirection: "column"
});

const promotionWrap = css({
    display: "flex",
    flexDirection: "column",
    border: "solid 1px var(--colors-gray-600)",
    borderBottom: "none"
});

const promotionContainerStyle = css({
    display: "flex",
    flexDirection: "row",
    gap: 3,
    borderBottom: "solid 1px var(--colors-gray-600)",
    p: 3
});

const promotionButtonStyle = css({
    display: "flex",
    width: "fit-content",
    textTransform: "uppercase"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {StarFillIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {InquiryButtonTypeName} from "../../../../../constants/inquiry_button_type";
import {useResponsiveLinkTarget} from "../../../../hooks/useResponsiveLinkTarget";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {getPromotionTypeName} from "../../../../promotion/helpers/PromotionType";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {getVendorPromotions} from "../../../helpers/get_vendor_promotions";
import {IVendorDetail} from "../../../types/IVendorDetail";

interface IProps {
    vendor: IVendorDetail;
}

export const VendorDetailReportModalContentPromotions = (props: IProps) => {
    const {vendor} = props;
    const {isMobile} = useUserDevice();
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const promotions = vendor.promotions;
    const renderPromotions = getVendorPromotions({promotions});

    if (renderPromotions.length === 0) {
        return null;
    }

    const promotionOffers = renderPromotions.map((promotion) => ({
        ...promotion,
        offerLink: useOfferLink({
            ...promotion.offer,
            vendor: {slug: vendor.slug}
        })
    }));

    return (
        <>
            <div className={subHeaderStyle}>
                <StarFillIcon size="3" />
                <Text variant="mini_header">OFERTY SPECJALNE</Text>
            </div>
            <div className={promotionWrap}>
                {promotionOffers.map((promotion) => {
                    const handlePromotionClick = () => {
                        if (promotion.offerLink) {
                            window.open(promotion.offerLink, responsiveLinkTarget);
                        }
                    };
                    return (
                        <div key={promotion.id} className={promotionContainerStyle}>
                            <Image
                                width={isMobile ? "120" : "240"}
                                height={isMobile ? "74" : "148"}
                                alt="zdjęcie oferty specjalnej"
                                src={getThumbnailLink(promotion.offer.main_image_url, 375, 211) ?? undefined}
                            />
                            <div className={promotionDetailsContainerStyle}>
                                <Text variant="mini_header" className={promotionHeaderStyle}>
                                    {getPromotionTypeName(promotion.type)}
                                </Text>
                                <Text variant="headline_6" mb={1}>
                                    {promotion.offer.name}
                                </Text>
                                <Text variant="info_txt_1" mb={2}>
                                    {promotion.name}
                                </Text>
                                <Button variant="filled_secondary" size="x-small" className={promotionButtonStyle} onClick={handlePromotionClick}>
                                    {InquiryButtonTypeName.SEE_DETAILS}
                                </Button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

const subHeaderStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
    mb: 4
});

const promotionHeaderStyle = css({
    backgroundColor: "var(--colors-success)",
    p: 0.5,
    mb: 2,
    width: "fit-content",
    textTransform: "uppercase"
});

const promotionDetailsContainerStyle = css({
    display: "flex",
    flexDirection: "column"
});

const promotionWrap = css({
    display: "flex",
    flexDirection: "column",
    border: "solid 1px var(--colors-gray-600)",
    borderBottom: "none"
});

const promotionContainerStyle = css({
    display: "flex",
    flexDirection: "row",
    gap: 3,
    borderBottom: "solid 1px var(--colors-gray-600)",
    p: 3
});

const promotionButtonStyle = css({
    display: "flex",
    width: "fit-content",
    textTransform: "uppercase"
});
